export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export function monthLabel(m) {
  if (!m) return "";
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("en-GB", { month: "long", year: "numeric" });
}

export function monthOptions(back = 2, forward = 12) {
  const arr = [];
  const d = new Date();
  for (let i = forward; i >= -back; i--) {
    const dd = new Date(d.getFullYear(), d.getMonth() + i, 1);
    arr.push(`${dd.getFullYear()}-${String(dd.getMonth() + 1).padStart(2, "0")}`);
  }
  return arr;
}

export function formatIDR(n) {
  return "Rp " + Number(n || 0).toLocaleString("id-ID");
}

export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export const MONTH_ABBR = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const currentYear = () => new Date().getFullYear();
export function yearOptions() {
  const y = new Date().getFullYear();
  return [y + 1, y, y - 1];
}

export function elapsedWeeks(month) {
  const cur = currentMonth();
  if (month < cur) return 5;
  if (month > cur) return 0;
  const d = new Date();
  return Math.min(5, Math.ceil(d.getDate() / 7));
}

export function pacing(month, achievedPct) {
  const elapsed = elapsedWeeks(month);
  const expected = Math.round((elapsed / 5) * 100);
  if (elapsed === 0) return { label: "Not started", tone: "slate", expected, elapsed };
  if (achievedPct >= 100) return { label: "Target met", tone: "emerald", expected, elapsed };
  if (achievedPct >= expected) return { label: "On track", tone: "emerald", expected, elapsed };
  if (achievedPct >= expected * 0.7) return { label: "Slightly behind", tone: "amber", expected, elapsed };
  return { label: "Behind", tone: "rose", expected, elapsed };
}
